<template>
  <div>
    <b-row class="justify-content-md-center">
      <div cols="12" md="12">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <b-col cols="12" md="12">
        <p class="text-center">
          {{ data.mensaje }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"

export default {
  name: "buscando",
  props: ["data"],
  created() {
    if (this.data == null || this.data == undefined) {
      return this._$goToInicio()
    }
    this.exeAxios()
  },
  beforeCreate() {},
  methods: {
    async exeAxios() {
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      this.$axiosHandlerAs.prepare(this.data.methodData.url, header, this.data.methodData.data)
      this.$axiosHandlerAs.overlay(false)
      await this.$axiosHandlerAs.exe()
      this.manejoRs(this.$axiosHandlerAs.getData(), this.$axiosHandlerAs.getStatus())
    },
    manejoRs(rs, status) {
      if (status) {
        this.data.data2To["rs"] = rs
        return this.$router.push({
          name: this.data.to,
          params: { data: this.data.data2To }
        })
      }
      this._$goToInicio()
    },
    showLoading() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
        "is-full-page": false
      })
    }
  },
  computed: {
    ...mapGetters("app", {
      appData: "getApp"
    })
  },
  data() {
    return {
      fullPage: false
    }
  }
}
</script>
<style scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #ba093e;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #ba093e transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
